//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"AngleOption",1,0],[1,"AngularDimension",0,"Expression",0],[0,"ChamferBothSides",1,0],[0,"ChordalTolerance",1,0],[0,"ClearanceTolerance",1,0],[1,"Depth",0,"Expression",0],[0,"EndPlane",1,"Plane",0],[0,"OffsetOption",1,0],[1,"Ratio",0,"Expression",0],[0,"ReferenceInternalBody",1,0],[1,"RestDepth",0,"Expression",0],[0,"ReverseDirection",1,0],[1,"SelectEdge",0,"ScCollector",0],[1,"SelectTarget",0,"ScCollector",0],[1,"SelectThinnerPlate",0,"ScCollector",0],[1,"SelectTool",0,"ScCollector",0],[0,"StartPlane",1,"Plane",0],[0,"Type",1,0],[0,"UseLimits",1,0]],[],[]];
SPLM.Features.ShipDesign.PlateChamferBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.PlateChamferBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.PlateChamferBuilder.Types = Object.freeze({
    "OnEdge" : "OnEdge", "ToPlate" : "ToPlate"});

SPLM.Features.ShipDesign.PlateChamferBuilder.AngleMethod = Object.freeze({
    "Angle" : "Angle", "Ratio" : "Ratio"});

SPLM.Features.ShipDesign.PlateChamferBuilder.OffsetMethod = Object.freeze({
    "Depth" : "Depth", "RestDepth" : "RestDepth", "ThinnerPlate" : "ThinnerPlate"});

export default SPLM;